import { render } from "./QrcodeComponent.vue?vue&type=template&id=01b8db3c&scoped=true"
import script from "./QrcodeComponent.vue?vue&type=script&lang=js"
export * from "./QrcodeComponent.vue?vue&type=script&lang=js"

import "./QrcodeComponent.vue?vue&type=style&index=0&id=01b8db3c&scoped=true&lang=css"

import exportComponent from "/Users/andreavadacchino/Desktop/pADV/untitled/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01b8db3c"]])

export default __exports__